<pcg-header id='mainTopHeader'></pcg-header>
<pcg-push-notification></pcg-push-notification>
<div class='main-container'>
	<div class='container p-2'>
		<router-outlet></router-outlet>
	</div>
</div>
<pcg-system-message></pcg-system-message>
<pcg-spinner></pcg-spinner>